import dbc from '@/api/configCenter/dimension.matrix';

const queryList = {
  namespaced: true,
  state: {},
  actions: {
    // 产品矩阵-模块

    /**
     * 获取产品矩阵所有数据
     * @param {*} store
     * @param {*} param
     */
    getproductMatrixList(context, param) {
      return dbc.getproductMatrixList(param).then((content) => content.list);
    },

    /**
     * 获取 某一条 产品矩阵信息
     * @param {*} store
     * @param {*} param
     */
    getproductMatrixById(context, param) {
      return dbc.getproductMatrixById(param).then((content) => content.data);
    },

    /**
     * 保存一条产品矩阵数据
     * @param {*} store
     * @param {*} param
     */
    saveproductMatrix(context, param) {
      return dbc.saveproductMatrix(param).then((content) => content.data);
    },

    /**
     * 删除一条产品矩阵数据数组
     * @param {*} param
     */
    deleteproductMatrixById(context, param) {
      return dbc.deleteproductMatrixById(param).then((content) => content.data);
    },
    /**
     * 同步产品矩阵
     * @param {*} param
     */
    syncproductMatrix(context, param) {
      return dbc.syncproductMatrix(param).then((content) => content.data);
    },
    /**
     * @description: 产品矩阵移动目标
     * @param {*}
     * @return {*}
     */
    moveProduct(context, param) {
      return dbc.moveProduct(param).then((content) => content.data);
    },
  },

  mutations: {},
};

export default queryList;
